<template>
    <div>
        <div class="col-12">
            <TitleComponent title="Selecciona tus entradas:"/>
        </div>
        <div class="col-12">
            <table class="table table-hover text-nowrap">
                <thead>
                    <tr>
                        <th></th>
                        <th>{{ $t('evento.tipo_entrada') }}</th>
                        <th>Precio</th>
                        <th>Cantidad</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(entrada, index) in entradas">
                        <tr :key="index">
                            <td :class="getEntradasMax(entrada) > 0 ? 'availability' : 'bg-danger'"></td>
                            <td>{{ entrada.descripcion }}</td>
                            <td>{{ getPrecioEntrada(entrada) | formatear_precio }}</td>
                            <td>
                                <div class="form-group" v-if="getEntradasMax(entrada) > 0">
                                    <select class="form-control" v-model="entrada.unidades" @change="actualizar" :disabled="disableInput">
                                        <option calue="0">0</option>
                                        <template v-for="i in getEntradasMax(entrada)">
                                            <option :key="i" :value="i">{{ i }}</option>
                                        </template>
                                    </select>
                                </div>
                                <template v-else>
                                    <b class="text-danger">ENTRADAS AGOTADAS</b>
                                </template>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';

    export default {
        props: ['entradas', 'event', 'disableInput'],
        methods: {
            actualizar() {
                this.loading = true;

                this.$emit('actualizar', true);

                this.loading = false;
            },
            getEntradasMax(entrada) {
                var max = entrada.n_entradas_max ? entrada.n_entradas_max : 8;

                if(max > 100) {
                    max = 100;
                }

                return entrada.units > max ? max : entrada.units;
            },
            getPrecioEntrada(entrada) {
                if(entrada.price_management_taquilla_interno) {
                    return entrada.precio;
                } else {
                    return entrada.total_price;
                }
            }
        },
        components: {
            TitleComponent
        }
    }
</script>

<style>

</style>
